export enum QUERY_KEYS {
  TOOL = 'TOOL',
  TOOLS = 'TOOLS',
  TOOL_REFERENCES = 'TOOL_REFERENCES',
}

export default QUERY_KEYS
